import { render, staticRenderFns } from "./SettingBackgroundPictureComponent.vue?vue&type=template&id=215a1cca&scoped=true&"
import script from "./SettingBackgroundPictureComponent.vue?vue&type=script&lang=js&"
export * from "./SettingBackgroundPictureComponent.vue?vue&type=script&lang=js&"
import style0 from "./SettingBackgroundPictureComponent.vue?vue&type=style&index=0&id=215a1cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215a1cca",
  null
  
)

export default component.exports